export default __webpack_public_path__ + "static/media/sc23.2bd8c9ab.mp4";